import PropTypes from 'prop-types'
import { colors, makeStyles } from '@material-ui/core'

const styles = ({ errors, attachmentControlName }) =>
  makeStyles((theme) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    gridContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing(2),
    },
    styledButton: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      backgroundColor: colors.grey[100],
      paddingInline: theme.spacing(4),
      textTransform: 'lowercase',
      '&:hover': {
        backgroundColor: colors.grey[200],
      },
    },
    nameFile: {
      color: colors.pink[300],
      paddingRight: theme.spacing(1),
    },
    cancelIcon: {
      color: colors.grey[400],
      display: 'flex',
      paddingLeft: '2px',
      flexWrap: 'nowrap',
    },
    errorColor: {
      color: !!errors?.[attachmentControlName]
        ? theme.palette.error.main
        : 'primary',
    },
    deadlineBox: {
      display: 'flex',
      alignItems: 'start',
      backgroundColor: colors.blueGrey[700],
      borderRadius: theme.shape.borderRadius,
      paddingBlock: theme.spacing(1),
      paddingInline: theme.spacing(2),
      marginInline: theme.spacing(2),
      marginBottom: theme.spacing(2),
      gridGap: theme.spacing(2),
      color: theme.palette.common.white,
    },
    buttonGroupContainer: {
      display: 'flex',
      width: '100%',
      gridGap: theme.spacing(1),
      justifyContent: 'space-between',
      alignContent: 'center',
    },
    infoIconButton: {
      cursor: 'help',
    },
  }))

styles.propTypes = {
  errors: PropTypes.object,
  attachmentControlName: PropTypes.string.isRequired,
}

export default styles
